module.exports = __webpack_public_path__ + "img/screen2.df8aa072.svg";